import { Config } from "src/Utils/ConfigService/LoadConfig";
import { usePostRequest } from "../ApiWrappers/usePostRequest";
import { useCallback, useRef } from "react";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";

export const useCancelSubscription = () => {
    const {postRequest, reqestResponse, reqestError, reqestLoading} = usePostRequest();
    const baseUrl = Config.GetConfigData().auraLicensingService.serviceUrl;
    const clinicIdRef = useRef<string>('');

    const cancelSubscription = useCallback((clinicId: string) => {
        const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/subscription/cancel`;
        logger.logInformation(`Request to cancel subscription license for the given clinic ${clinicId} was made`);
        postRequest<any>({}, requestUrl);
        clinicIdRef.current = clinicId;
    }, [baseUrl, postRequest]);

    return {reqestResponse, reqestError, reqestLoading, cancelSubscription};
}
